module.exports = __webpack_public_path__ + "static/pill-royal-877fab5e682d8edb5ec5b1070be84a8e.svg";